import { Bank } from 'app/modules/masters/bank/models/bank.model';

export interface BankState {
  banks: Bank[];
  loading: boolean;
  error: any;
  total: number;
  page: number;
  pageSize: number;
  sortBy: 'createdAt' | 'name' | 'accountType' | 'ifsc' | 'accountNumber' | 'currentBalance' | 'status';
  sortOrder: 'asc' | 'desc';
}

export const initialBankState: BankState = {
  banks: [],
  loading: false,
  error: null,
  total: 0,
  page: 0,
  pageSize: 10,
  sortBy: 'createdAt',
  sortOrder: 'desc',
};
